import { makeStyles, shorthands } from "@fluentui/react-components";

export const reorderDialogStyles = makeStyles({
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    width: "434px",
    height: "226px",
    "@media (max-width: 499px)": {
      width: "90%",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    height: "72px",
  },
  dialogTitle: {
    display: "flex",
    fontWeight: 700,
    fontSize: "18px",
  },
  dialogBody: {
    display: "flex",
    height: "61px",
    fontWeight: 400,
  },
  dialogButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    ...shorthands.padding("20px", "10px", "0px", "0px"),
  },
  cancelButton: {
    height: "32px",
  },
  continueButton: {
    height: "32px",
  },
});
